import { useState, useEffect, useCallback } from 'react';

const KEY = 'cart';

export const readCart = () => {
    try {
        const raw = localStorage.getItem(KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
};

export const writeCart = (items) => {
    try {
        localStorage.setItem(KEY, JSON.stringify(items || []));
    } catch (e) { /* storage full / private mode */ }
    window.dispatchEvent(new Event('cartUpdated'));
};

export const clearCart = () => {
    try { localStorage.removeItem(KEY); } catch (e) { }
    window.dispatchEvent(new Event('cartUpdated'));
};

export const cartCount = (items) =>
    (items || []).reduce((n, it) => n + (Number(it.qty) || 1), 0);

export const cartTotal = (items) =>
    (items || []).reduce((sum, it) => {
        const line = Number(it.total);
        return sum + (Number.isFinite(line) && line > 0 ? line : (Number(it.price) || 0) * (Number(it.qty) || 1));
    }, 0);

/** Live cart state — stays in sync across pages, tabs and components. */
export default function useCart() {
    const [items, setItems] = useState(readCart);

    useEffect(() => {
        const sync = () => setItems(readCart());
        window.addEventListener('cartUpdated', sync);
        window.addEventListener('storage', sync);
        return () => {
            window.removeEventListener('cartUpdated', sync);
            window.removeEventListener('storage', sync);
        };
    }, []);

    const update = useCallback((next) => {
        setItems(next);
        writeCart(next);
    }, []);

    return { items, setItems: update, count: cartCount(items), total: cartTotal(items) };
}
